import React, { useRef, useState } from "react";
import { api } from "@/lib/api";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Resize + compress to a max dimension to keep payload small
const compressImage = (file, maxDim = 512, quality = 0.85) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > height && width > maxDim) {
          height = Math.round((height * maxDim) / width);
          width = maxDim;
        } else if (height > maxDim) {
          width = Math.round((width * maxDim) / height);
          height = maxDim;
        }
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const AvatarUploader = ({ onUploaded, className = "" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const onChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Vui lòng chọn file ảnh");
      return;
    }
    setBusy(true);
    try {
      const data = await compressImage(file, 512, 0.82);
      const { data: updated } = await api.post("/me/avatar", { data });
      toast.success("Đã cập nhật avatar");
      onUploaded?.(updated);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Tải ảnh lỗi");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <>
      <input ref={ref} type="file" accept="image/*" onChange={onChange} className="hidden" data-testid="avatar-input" />
      <button onClick={() => ref.current?.click()} disabled={busy} data-testid="avatar-upload-btn"
        className={`px-3 py-2 rounded-md text-xs border border-cyan-400/40 text-cyan-300 hover:bg-cyan-400/10 disabled:opacity-50 flex items-center gap-1.5 ${className}`}>
        {busy ? <Loader2 size={12} className="animate-spin" /> : <Upload size={12} />} Tải avatar
      </button>
    </>
  );
};

export default AvatarUploader;
